/* eslint-disable sort-keys-fix/sort-keys-fix -- CSS-in-JS pseudo-selector keys use semantic ordering */
// MUI v4 TableSortLabel — NS/Tractie component overrides.
// All MUI v4 style classes are declared explicitly (no implicit inheritance on MUI defaults).
// Tractie deviation: focus + hover color via NS interactive-fg tokens (mode-aware)
// i.p.v. MUI default text.secondary. active state = fg-default (donkere tekst,
// hoogste contrast). icon transition: none (ground-rules.md "Motion and text": geen animatie) — MUI default
// fade-in op opacity wordt instant.

export const MuiTableSortLabelLightOverrides = {
  root: {
    cursor: 'pointer' as const,
    display: 'inline-flex' as const,
    justifyContent: 'flex-start' as const,
    flexDirection: 'inherit' as const,
    alignItems: 'center' as const,
    '&:focus': {
      color: 'var(--ns-color-fg-interactive-default)',
    },
    '&:hover': {
      color: 'var(--ns-color-fg-interactive-hover)',
      '& $icon': {
        opacity: 0.5,
      },
    },
    '&$active': {
      color: 'var(--ns-color-fg-default)',
      '&& $icon': {
        opacity: 1,
        color: 'var(--ns-color-fg-default)',
      },
    },
  },

  active: {},

  icon: {
    fontSize: 18,
    marginRight: 4,
    marginLeft: 4,
    opacity: 0,
    transition: 'none',
    userSelect: 'none' as const,
  },

  iconDirectionDesc: {
    transform: 'rotate(0deg)',
  },

  iconDirectionAsc: {
    transform: 'rotate(180deg)',
  },
} as const;

// Dark variant — alle kleur-tokens zijn mode-aware via tokens.css.
export const MuiTableSortLabelDarkOverrides = {
  ...MuiTableSortLabelLightOverrides,
} as const;
